import React, { useContext } from "react";

import constant from "lib/constant/constant";

import { PrivateContext } from "lib/context";
import { Spinner } from "lib/components";
import { storageHelper } from "lib/helpers";

import { OperatorOrderView } from "./operator/features";
import { ProviderOrderView } from "./provider/features";

const { userKey } = constant;
const { operator, provider } = userKey;

const OrderLakeSlip = () => {
  const { isLoading } = useContext(PrivateContext);

  const getComponent = (role) => {
    if (isLoading) {
      return <Spinner />;
    }
    if (role === operator) {
      return <OperatorOrderView />;
    }
    if (role === provider) {
      return <ProviderOrderView />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const OrderViewComponent = getComponent(currentUserRole);
  return OrderViewComponent;
};

export default OrderLakeSlip;
